import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import classnames from 'classnames';
import Popover from '../Popover';
import { defaultProps } from '../utils/defaultProps';
import { breadcrumbClass } from './styles';
import { getKey } from '../utils/uid';
import Caret from '../icons/Caret';

var defaultValue = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  data: [],
  separator: '/'
});

var Breadcrumb =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Breadcrumb, _React$PureComponent);

  var _super = _createSuper2(Breadcrumb);

  function Breadcrumb() {
    _classCallCheck(this, Breadcrumb);

    return _super.apply(this, arguments);
  }

  _createClass(Breadcrumb, [{
    key: "renderArray",
    value: function renderArray(data) {
      var _this = this;

      var first = data[0];
      return (
        /*#__PURE__*/
        React.createElement("span", null, this.renderItem(first),
        /*#__PURE__*/
        React.createElement("span", {
          className: breadcrumbClass('down')
        },
        /*#__PURE__*/
        React.createElement(Caret, null)),
        /*#__PURE__*/
        React.createElement(Popover, {
          position: "bottom"
        }, data.slice(1).map(function (d, i) {
          return (
            /*#__PURE__*/
            React.createElement("div", {
              className: breadcrumbClass('dropdown-item'),
              key: i
            }, _this.renderItem(d))
          );
        })))
      );
    }
  }, {
    key: "renderItem",
    value: function renderItem(dataItem) {
      var renderItem = this.props.renderItem;
      var d = dataItem;
      var item = d.title;

      if (!
      /*#__PURE__*/
      React.isValidElement(item)) {
        if (d.onClick || d.url) {
          var props = {
            onClick: d.onClick
          };
          if (d.url) props.href = d.url;
          item =
          /*#__PURE__*/
          React.createElement("a", props, d.icon, "\xA0", d.title);
        } else {
          item =
          /*#__PURE__*/
          React.createElement("b", null, d.icon, "\xA0", d.title);
        }
      }

      return renderItem ? renderItem(dataItem) : item;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          data = _this$props.data,
          separator = _this$props.separator,
          keygen = _this$props.keygen;
      var className = classnames(breadcrumbClass('_'), this.props.className);
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className,
          style: this.props.style
        }, data && data.map(function (d, index) {
          return (
            /*#__PURE__*/
            React.createElement("span", {
              key: keygen ? getKey(d, keygen, index) : index
            }, Array.isArray(d) ? _this2.renderArray(d) : _this2.renderItem(d), index !== data.length - 1 ?
            /*#__PURE__*/
            React.createElement("span", {
              className: breadcrumbClass('separator')
            }, separator) : null)
          );
        }))
      );
    }
  }]);

  return Breadcrumb;
}(React.PureComponent);

Breadcrumb.defaultProps = defaultValue;
Breadcrumb.displayName = void 0;
Breadcrumb.displayName = 'ShineoutBreadcrumb';
export default Breadcrumb;